const BASE_PATH = 'api/observation-assignments/'

const types = {
  OBSERVATION_ASSIGNMENTS_FETCH_REQUEST: BASE_PATH + 'OBSERVATION_ASSIGNMENTS_FETCH_REQUEST',
  OBSERVATION_ASSIGNMENTS_FETCH_FAILURE: BASE_PATH + 'OBSERVATION_ASSIGNMENTS_FETCH_FAILURE',
  OBSERVATION_ASSIGNMENTS_FETCH_SUCCESS: BASE_PATH + 'OBSERVATION_ASSIGNMENTS_FETCH_SUCCESS',
  OBSERVATION_ASSIGNMENTS_SET_ACTIVE: BASE_PATH + 'OBSERVATION_ASSIGNMENTS_SET_ACTIVE',
}

export default types